import { createContext } from 'react'

const MyContext = createContext({
    ref: null as any,
})
export default MyContext
